import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import toast from 'react-hot-toast';
import '../styles/AddStudent.css';

const AddStudent = () => {
    const [student, setStudent] = useState({
        user_id: '',
        first_name: '',
        last_name: '',
        email: '',
        grade: '',
        profile_picture: ''
    });
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Handle form changes
    const handleChange = async (e) => {
        setStudent({ ...student, [e.target.name]: e.target.value });
    };
    
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate all fields
        let isValid = true;
        let errorMessage = '';

        // Validate user_id if provided
        if (student.user_id && !/^\d{6}$/.test(student.user_id)) {
            isValid = false;
            errorMessage = 'User ID must be a six digit number';
        }
        // Validate first_name
        else if (!/^[A-Za-z() ]+$/.test(student.first_name)) {
            isValid = false;
            errorMessage = 'First name must contain only letters, spaces, and brackets';
        }
        // Validate last_name
        else if (!/^[A-Za-z() ]+$/.test(student.last_name)) {
            isValid = false;
            errorMessage = 'Last name must contain only letters, spaces, and brackets';
        }
        // Validate grade
        else {
            const gradeNum = parseInt(student.grade);
            if (isNaN(gradeNum) || gradeNum < 6 || gradeNum > 12) {
                isValid = false;
                errorMessage = 'Grade must be a number between 6 and 12';
            }
        }

        if (!isValid) {
            toast.error(errorMessage, {
                iconTheme: {
                    primary: '#FFFFFF',
                    secondary: '#E61920',
                },
                style: {
                    backgroundColor: '#E61920',
                    color: '#FFFFFF',
                },
            });
            return;
        }

        try {
            await axios.post(`${API_URL}/api/students`, student, {});
            navigate('/edit-students');
            toast.success('Student added successfully!', {
                iconTheme: {
                    primary: '#333',
                    secondary: '#DCB41F',
                },
                style: {
                    backgroundColor: '#333',
                    color: '#DCB41F',
                },
            });

        } catch (err) {
            setError(err.response?.data?.message || err.message);
        }
    };

    // Handle form cancel
    const handleCancel = () => {
        navigate('/edit-students');
        toast('No changes were made.', {
            iconTheme: {
                primary: '#333',
                secondary: '#DCB41F',
            },
            style: {
                backgroundColor: '#333',
                color: '#DCB41F',
            },
        });
    };

    return (
        <div>
            <Header />
            <div className="add-student-container">
                <h2>Add New Student</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input type="text" name="user_id" placeholder="User ID (optional)" onChange={handleChange} />
                    <input type="text" name="first_name" placeholder="First Name" onChange={handleChange} required />
                    <input type="text" name="last_name" placeholder="Last Name" onChange={handleChange} required />
                    <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
                    <input type="text" name="grade" placeholder="Grade" onChange={handleChange} required />
                    <div className="button-group">
                        <button type="submit">Add Student</button>
                        <button type="button" onClick={handleCancel}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddStudent;